import { Card } from '@payaca/ambrosia';
import LabelValuePair from '@payaca/components/labelValuePair/LabelValuePair';

import { SearchDevice } from '@payaca/types/deviceTypes';
import { FC } from 'react';

export interface IProps {
  selectedDevice: SearchDevice;
}

const SearchedDeviceDetailsCard: FC<IProps> = (props) => {
  const { selectedDevice } = props;

  const labels = [
    {
      label: 'Device reference',
      value: selectedDevice.reference,
    },
    {
      label: 'Device model number',
      value: selectedDevice.model,
    },
    {
      label: 'Number of phases',
      value: selectedDevice.phases,
    },
    {
      label: 'Manufacturer',
      value: selectedDevice.manufacturer,
    },
  ];
  if (selectedDevice.deviceSize) {
    labels.push({
      label: selectedDevice.deviceSize.name,
      value: `${selectedDevice.deviceSize.size} ${selectedDevice.deviceSize.unit}`,
    });
  }

  return (
    <Card>
      <Card.Body>
        <h4>Selected device details</h4>

        {labels.map(({ label, value }) => (
          <LabelValuePair key={value} label={label} value={value} />
        ))}
      </Card.Body>
    </Card>
  );
};

export default SearchedDeviceDetailsCard;
